import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiZod } from '@/shared/api'
import { type Company, CompanySchema } from '../model/schema'

export const companyKeys = {
  all: ['companies'] as const,
  list: () => [...companyKeys.all, 'list'] as const,
}

// Справочник компаний из проекции хаба: архивные и скрытые для telemost бэк не
// отдаёт. Список маленький (десятки) — грузим целиком и держим в кэше: он питает
// и фильтр списка встреч, и пикер при создании.
export function companiesQueryOptions() {
  return queryOptions({
    queryKey: companyKeys.list(),
    queryFn: async (): Promise<Company[]> => {
      const body = await apiGet('/companies', apiZod.zListCompaniesResponse)
      return (body.data ?? []).map((dto) =>
        CompanySchema.parse({ id: dto.id, name: dto.name, slug: dto.slug }),
      )
    },
    staleTime: 5 * 60 * 1000,
  })
}
